import { IOffer as IOfferExternal } from '../../../../shared/repositories/search-offers/v2/types';

export interface IOffer extends IOfferExternal {}

export interface IOfferAnalyticsInfo {
  id?: number;
  name?: string;
  price?: number;
  brand?: string;
  category?: string;
  variant?: string;
  quantity: number;
}

export * from '../../../../shared/repositories/search-offers/v2/types';
export * from '../../../../shared/repositories/search-offers/v2/types/photoLabels';
